import { Injectable } from '@angular/core';
import { Result } from '../../../../domain/models/http-response.model';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { AuthRepository } from '../../../../domain/repositories/auth.repository';

@Injectable({ providedIn: 'root' })
export class VerifyEmailResendUseCase
  implements Usecase<{}, Promise<Result<any, any>>>
{
  constructor(private authRepository: AuthRepository) {}
  execute(): Promise<Result<any, any>> {
    return this.authRepository.verifyEmailResend();
  }
}
